
import { Box, Typography, Link, Avatar } from '@mui/material';
import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import Iconify from '../../Iconify';
import useLocales from '../../../hooks/useLocales';


// ----------------------------------------------------------------------

Licences.propTypes = {
  license: PropTypes.number,
};

export default function Licences({ license }) {
  const { translate } = useLocales();
  const [licenceData, setLicenceData] = useState(null);

  useEffect(() => {
    if(license) {
      switch (license) {
        case 1:
        setLicenceData({
          name: 'CC-BY',
          link: 'https://creativecommons.org/licenses/by/4.0/',
          description: [
            {
              icon: 'material-symbols:man',
              translatableText: 'objects.giveCredit',
            }
          ]

        });
          break;
        case 2:
          setLicenceData({
            name: 'CC-BY-NC-ND',
            link: 'https://creativecommons.org/licenses/by-nc-nd/4.0/',
            description: [
              {
                icon: "mdi:money-off",
                translatableText: 'objects.doNotCommerical',
              },
              {
                icon: "ic:baseline-equals",
                translatableText: 'objects.doNotDerivate',
              },
              {
              icon: 'material-symbols:man',
              translatableText: 'objects.giveCredit',
              }
            ]
          });
          break;
        default:
          break;
      }
    }
  }, [license])
  
  return (
    <>
        <Box display="inline-flex" alignItems="flex-start" sx={{ padding: '10px' }}>
          <Box  sx={{ fontSize: '13px', color: "common.white" }}>
            {!license || license === 0 ?
                translate('objects.licenceCC')
                :
                (
                  <>
                    <Typography variant="body2" color="common.white" sx={{ fontWeight: "bold", display: 'inline', fontSize: '15px' }}>
                      {licenceData?.name} {translate('objects.license')}
                    </Typography>
                    {translate('objects.licenseBYusage')}
                    {licenceData?.description.map((item) => (
                    <Box key={item.icon} sx={{display: "flex", gap: 0.5, alignItems: "center", mt: 0.5}}>
                        <Avatar  sx={{ width: 23, height: 23, backgroundColor: "rgba(255,0,0, 0)", border: "2px solid white" }}>
                          <Iconify color="#fff" icon={item.icon} width={17} height={17} />
                        </Avatar>
                        {translate(item.translatableText)}
                    </Box>
                    ))}
                    <Box sx={{display: "flex", gap: 1, alignItems: "center", mt: 0.5, mb: 1}}>
                      <Avatar  sx={{ width: 23, height: 23, backgroundColor: "rgba(255,0,0, 0)", border: "2px solid white" }}>
                        <Iconify color="#fff" icon="uil:info" width={17} height={17} />
                      </Avatar>
                      <Box sx={{textDecoration: "underline"}}>
                      <Link
                          href={licenceData?.link}
                          target={'_blank'}
                          rel="noreferrer"
                          sx={{
                            color: 'white',
                            fontWeight: '600',
                            '&:focus': { textDecoration: 'none' },
                            '&:hover': { textDecoration: 'none' },
                            '&:visited': { textDecoration: 'none' },
                            '&:link': { textDecoration: 'none' },
                            '&:active': {
                              textDecoration: 'none',
                            },
                          }}
                          >
                          {translate('objects.licenseMore')}
                          {licenceData?.name}
                        </Link>
                      </Box>
                    </Box>
                  
                    </>
                  ) 
              }
          </Box>
        </Box>
      </>
  );
}

